var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "media-list__item media-list__item-video",
      on: { click: _vm.openDialog },
    },
    [
      _c("video", { staticClass: "media-list__player" }, [
        _c("source", { attrs: { src: _vm.url } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }